import * as React from "react";
import { SVGProps, memo } from "react";

const SvgCheckInQrCode = (props: SVGProps<SVGSVGElement>) => (
  <svg width={64} height={64} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.25 19.826v31.806a2.87 2.87 0 0 0 2.87 2.868h20.735a2.868 2.868 0 0 0 2.867-2.867V12.367A2.867 2.867 0 0 0 42.855 9.5H22.12a2.87 2.87 0 0 0-2.87 2.867v7.644"
      fill="#ECF9F2"
    />

    <path
      d="M19.25 19.826v31.806a2.87 2.87 0 0 0 2.87 2.868h20.735a2.868 2.868 0 0 0 2.867-2.867V12.367A2.867 2.867 0 0 0 42.855 9.5H22.12a2.87 2.87 0 0 0-2.87 2.867v7.644"
      stroke="#194D33"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M41.38 22.5H23.648a.899.899 0 0 0-.898.899V41.13c0 .496.402.899.898.899H41.38a.899.899 0 0 0 .898-.899V23.399a.899.899 0 0 0-.898-.899Z"
      fill="#fff"
    />

    <path d="M38.577 38.398h-3.55v.808h4.364v-4.308h-.814v3.503-.003Z" fill="#194D33" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.394 34.902c0-.101.082-.183.183-.183h.814c.102 0 .184.082.184.183v4.307a.183.183 0 0 1-.184.183h-4.363a.183.183 0 0 1-.183-.183v-.808c0-.1.082-.183.183-.183h3.366v-3.316Zm.366 3.503a.183.183 0 0 1-.218.18h-3.331v.441h3.997v-3.941h-.448v3.32Z"
      fill="#194D33"
    />

    <path d="M26.251 26.231h3.546v-.801h-4.364v4.304h.818v-3.503Z" fill="#194D33" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.25 25.433c0-.101.082-.183.183-.183h4.364c.1 0 .183.082.183.183v.802a.183.183 0 0 1-.183.183h-3.363v3.32a.183.183 0 0 1-.183.182h-.818a.183.183 0 0 1-.183-.183v-4.304Zm.366.183v3.938h.452v-3.32c0-.1.082-.183.183-.183h3.363v-.435h-3.998Z"
      fill="#194D33"
    />

    <path d="M35.028 25.43v.801h3.549v3.503h.815V25.43h-4.364Z" fill="#194D33" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.845 25.433c0-.101.082-.183.183-.183h4.363c.102 0 .184.082.184.183v4.304a.183.183 0 0 1-.184.183h-.814a.183.183 0 0 1-.183-.183v-3.32h-3.366a.183.183 0 0 1-.183-.183v-.801Zm.366.183v.436h3.366c.1 0 .183.081.183.183v3.32h.448v-3.939h-3.997Z"
      fill="#194D33"
    />

    <path d="M26.251 34.902h-.818v4.307h4.364v-.808H26.25v-3.503.004Z" fill="#194D33" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.251 34.71c.101 0 .183.083.183.184v3.32h3.363c.1 0 .183.082.183.183v.808a.183.183 0 0 1-.183.183h-4.364a.183.183 0 0 1-.183-.183v-4.308c0-.1.082-.183.183-.183h.783a.19.19 0 0 1 .035-.003Zm-.183.37v3.317c0 .1.082.183.183.183h3.363v.442h-3.998V35.08h.452Z"
      fill="#194D33"
    />

    <path
      d="M28.04 31.787h3.852V28H28.06l-.018 3.787Zm.767-3.03h2.297v2.27h-2.297v-2.27Z"
      fill="#194D33"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.876 28.002c0-.1.082-.182.183-.182h3.833c.101 0 .183.082.183.183v3.787a.183.183 0 0 1-.183.183h-3.851a.183.183 0 0 1-.184-.184l.019-3.787Zm.365.184-.017 3.42h3.485v-3.42h-3.468Zm.383.575c0-.101.082-.183.183-.183h2.297c.101 0 .183.082.183.183v2.269a.183.183 0 0 1-.183.183h-2.297a.183.183 0 0 1-.183-.183v-2.27Zm.366.183v1.902h1.93v-1.902h-1.93Z"
      fill="#194D33"
    />

    <path
      d="M28.04 36.987h3.852v-3.784H28.06l-.018 3.784Zm.767-2.983h2.297v2.269h-2.297v-2.27Z"
      fill="#194D33"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.876 33.198c0-.101.082-.182.183-.182h3.833c.101 0 .183.082.183.183v3.783a.183.183 0 0 1-.183.183h-3.851a.183.183 0 0 1-.184-.184l.019-3.783Zm.365.184-.017 3.417h3.485v-3.417h-3.468Zm.383.617c0-.1.082-.183.183-.183h2.297c.101 0 .183.082.183.183v2.27a.183.183 0 0 1-.183.182h-2.297a.183.183 0 0 1-.183-.183V34Zm.366.183v1.903h1.93v-1.903h-1.93Z"
      fill="#194D33"
    />

    <path
      d="M37.193 28h-3.834v3.787h3.834V28Zm-.814 3.03h-2.296v-2.26h2.293v2.26h.003Z"
      fill="#194D33"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.176 28.003c0-.1.082-.183.183-.183h3.834c.1 0 .183.082.183.183v3.787a.183.183 0 0 1-.183.183h-3.834a.183.183 0 0 1-.183-.183v-3.787Zm.366.183v3.42h3.468v-3.42h-3.468Zm.358.587c0-.101.081-.183.183-.183h2.293c.101 0 .183.082.183.183V31a.183.183 0 0 1-.18.217h-2.296a.183.183 0 0 1-.183-.183v-2.26Zm2.293 2.077h-1.927v-1.894h1.927v1.894Z"
      fill="#194D33"
    />

    <path
      d="M37.193 33.203h-3.834v3.784h3.834v-3.784Zm-.814 3.026h-2.296v-2.262h2.293v2.262h.003Z"
      fill="#194D33"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.176 33.199c0-.101.082-.183.183-.183h3.834c.1 0 .183.082.183.183v3.783a.183.183 0 0 1-.183.183h-3.834a.183.183 0 0 1-.183-.183V33.2Zm.366.183v3.417h3.468v-3.417h-3.468Zm.358.58c0-.1.081-.183.183-.183h2.293c.101 0 .183.082.183.183v2.23a.183.183 0 0 1-.18.217h-2.296a.183.183 0 0 1-.183-.184v-2.263Zm2.293 2.08h-1.927v-1.897h1.927v1.897Z"
      fill="#194D33"
    />

    <path
      d="M25.75 9.688v2.337a.662.662 0 0 0 .322.535c.23.153.503.234.78.231h11.333c.278.001.55-.08.781-.231a.662.662 0 0 0 .322-.535V9.687"
      stroke="#194D33"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Memo = memo(SvgCheckInQrCode);

export default Memo;
